var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuListAcademicBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    id: "svg429",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs433",
    fill: "#246abf"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath443",
    fill: "#246abf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,24 H 24 V 0 H 0 Z",
    id: "path441",
    fill: "#246abf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g435",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g439",
    clipPath: "url(#clipPath443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g445",
    transform: "translate(1.5,1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 21",
    id: "path447",
    className: "path-style-academic-building"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g449",
    transform: "translate(2.5,6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 19",
    id: "path451",
    className: "path-style-academic-building"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g453",
    transform: "translate(20.9971,18.1245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -7.16,3.907 c -1.145,0.625 -2.529,0.625 -3.674,0 L -17.994,0 c -0.5,-0.272 -0.923,-0.689 -1.25,-1.181 -0.693,-1.045 0.125,-2.444 1.378,-2.444 h 17.738 c 1.253,0 2.07,1.399 1.378,2.444 C 0.923,-0.689 0.5,-0.272 0,0 Z",
    id: "path455",
    className: "path-style-academic-building"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g457",
    transform: "translate(9.5,14.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -8",
    id: "path459",
    className: "path-style-academic-building"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g461",
    transform: "translate(14.5,14.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -8",
    id: "path463",
    className: "path-style-academic-building"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g465",
    transform: "translate(4.5,14.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -8",
    id: "path467",
    className: "path-style-academic-building"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g469",
    transform: "translate(19.5,14.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -8",
    id: "path471",
    className: "path-style-academic-building"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuListAcademicBuilding);
export default __webpack_public_path__ + "static/media/menu_list-academic_building.73ecd0e332bc97500047b1bb3d75dab4.svg";
export { ForwardRef as ReactComponent };